import React, { FC, memo, ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ListItem, Typography } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import { BlockIcon, UnblockIcon } from "../../../icons";
import BlockUserModal from "../../BlockUserModal/BlockUserModal";
import { processUserToBlocklist } from "../../../store/ducks/user/actionCreators";
import { selectUserDataId } from '../../../store/ducks/user/selectors';
import { setOpenSnackBar } from "../../../store/ducks/actionSnackbar/actionCreators";
import { useModalWindow } from "../../../hook/useModalWindow";
import { PROFILE } from '../../../constants/path-constants';

interface BlockUserButtonProps {
    tweetId: string;
    userId: string;
    username: string;
    isUserBlocked: boolean;
    onClose?: () => void;
}

const BlockUserButton: FC<BlockUserButtonProps> = memo((
    {
        tweetId,
        userId,
        username,
        isUserBlocked,
        onClose
    }
): ReactElement => {
    const dispatch = useDispatch();
    const location = useLocation();
    const myProfileId = useSelector(selectUserDataId);
    const { visibleModalWindow, onOpenModalWindow, onCloseModalWindow } = useModalWindow();

    const onBlockUser = (): void => {
        let hasProfileBlocked = true;
        if (location?.pathname?.includes(PROFILE)) {
            const profileUserId = location?.pathname?.split("/")[2];
            if (profileUserId && profileUserId === userId && myProfileId !== profileUserId) {
                hasProfileBlocked = false;
            }
        }
        dispatch(processUserToBlocklist({ userId, hasProfileBlocked, tweetId }));
        dispatch(setOpenSnackBar({
            message: `@${username} has been ${isUserBlocked ? "unblocked" : "blocked"}.`
        }));
        onCloseModalWindow();
        onClose && onClose();
    };

    return (
        <>
            <ListItem id={"onOpenBlockUserModal"} onClick={onOpenModalWindow}>
                <>{isUserBlocked ? UnblockIcon : BlockIcon}</>
                <Typography variant={"body1"} component={"span"}>
                    {isUserBlocked ? "Unblock" : "Block"} @{username}
                </Typography>
            </ListItem>
            <BlockUserModal
                username={username}
                isUserBlocked={isUserBlocked}
                visible={visibleModalWindow}
                onClose={onCloseModalWindow}
                onBlockUser={onBlockUser}
            />
        </>
    );
});

export default BlockUserButton;
